jQuery(function(){
    //menuCorrect();
    //jQuery(window).resize(function() {
        //menuCorrect();
    //});

    function hidemenuonswipe()
    {
        jQuery('.mobile-left-container').animate({right: '0%'}, 500);
        jQuery('.megacontainer').animate({right: '80%'}, 500);

        if(jQuery('body').find('.new-design_container')) {
            jQuery('.close-mobile-menu').delay(500).fadeIn();
            jQuery('.open-mobile-menu').fadeOut();
            jQuery('html, body').animate({ scrollTop: 0 });
        }
        else {
            jQuery('.close-mobile-menu').fadeIn();
            jQuery('.open-mobile-menu').fadeOut();
        }
    }

    function showmenuonswipe()
    {
        jQuery('.mobile-left-container').animate({right: '-80%'}, 500);
        jQuery('.megacontainer').animate({right: '0%'}, 500);
        if(jQuery('body').find('.new-design_container')) {
            jQuery('.close-mobile-menu').fadeOut(10);
            jQuery('.open-mobile-menu').delay(500).fadeIn();
        }
        else {
            jQuery('.close-mobile-menu').fadeOut();
            jQuery('.open-mobile-menu').fadeIn();
        }
    }

    // jQuery('body').bind('swiperight',showmenuonswipe);
    jQuery('.close-mobile-menu').click(showmenuonswipe);
    // jQuery('body').bind('swipeleft',hidemenuonswipe);
    jQuery('.open-mobile-menu').click(hidemenuonswipe);


    /* TIJDELIJK FAKE SUBMENU */
    jQuery('.mobile-menu-1 a').on('click touchend', function(e) {
        var hasSubitems = $(this).attr('data-hassubitems');
        if (hasSubitems == '1')
        {
            var subMenuClass = '.menu-' + $(this).data('submenuitem');
            jQuery('.mobile-menu-1').animate({right: '-=100%'}, 500);
            jQuery(subMenuClass).animate({right: '0%'}, 500);
            return false;
        }
        else
        {
            var href = $(this).attr('href');
            window.location.href = href;
            return false;
        }
    });
    jQuery('.mobile-submenu-titel').on('click touchend', function(e) {
        jQuery('.mobile-menu-1').animate({right: '0%'}, 500);
        jQuery('.mobile-menu-2').animate({right: '100%'}, 500);
    });


    jQuery('.mobile-menu-item').on('click touchend', function(e) {
        var index = jQuery('.mobile-menu-item').index(this);
        var html = jQuery('.mobile-menu-2-content:eq('+index+')').html();
        jQuery('.mobile-menu-2').html(html);



        jQuery('.subitemwithsubmenu').on('click touchend', function(e) {
            var index = jQuery('.subitemwithsubmenu').index(this);
            var html = jQuery('.mobile-menu-3-content:eq('+index+')').html();
            jQuery('.mobile-menu-3').html(html);

            jQuery('.mobile-menu-2').animate({right: '-=100%'}, 500);
            jQuery('.mobile-menu-3').animate({right: '0%'}, 500);

            jQuery('.mobile-menu-3').find('.mobile-submenu-titel').click(function(){
                jQuery('.mobile-menu-2').animate({right: '0%'}, 500);
                jQuery('.mobile-menu-3').animate({right: '100%'}, 500);
            });
            return false;
        })
    })
});
